import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import Input from "components/form/Input";
import GButton from "components/ui/button/Button";
import GModal from "components/ui/modal/Modal";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  editProduction,
  getProdBranchesDropList,
  getProductionDetails,
} from "../../services/productionService";

const EditProductionModal = ({ onClose, id }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, control, setValue } = useForm();

  const productionsData = useSelector((state) => state.productions);

  useEffect(() => {
    dispatch(getProdBranchesDropList());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.production.edit_production")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              if (values.BranchId === undefined) {
                toast2({ description: t("validation.choose_first") });
              } else {
                values.BranchId = values.BranchId.BranchId;
                values.ProductionId = id.ProductionId;
                dispatch(editProduction(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.production.production_updated"),
                    });
                    dispatch(getProductionDetails(id));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.inventory.branch")}
                data={productionsData.branchesDropData.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("BranchId", e)}
              />

              <Input
                label={t("pages.transfers_orders.notes")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.transfers_orders.notes")}
                name="Notes"
                isFormController
                control={control}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default EditProductionModal;
